import { PHONE, locationSchema } from "../structured-data-core";

export function getAustinStructuredData() {
  const url = "https://restorehair.com/locations/texas/austin/";
  const description =
    "Find out about your hair transplant options in Austin with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Austin", "300 Beardsley Lane, Bldg C, Suite 101", "Austin", "TX", PHONE, url, description),
  ];
}
